// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {DriverLoginReportBase, DriverLoginReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchDriverLoginReport(
  payload: DriverLoginReportPayload
): Promise<APIResponse<DriverLoginReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.driverLoginReport, payload)
  return response.data
}
